import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({ providedIn: 'root' })
export class TenantGuard implements CanActivate {
  private jwtHelper = new JwtHelperService();

  constructor(private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const token = localStorage.getItem('accessToken');
    if (!token || this.jwtHelper.isTokenExpired(token)) {
      this.router.navigate(['/login']);
      return false;
    }
    const decoded = this.jwtHelper.decodeToken(token);
    if (decoded?.user_type === 'tenant') {
      return true;
    }
    // Non-tenant users get redirected away
    this.router.navigate(['/dashboard']);
    return false;
  }
}
